import { render, staticRenderFns } from "./StyledVideojsPlayer.vue?vue&type=template&id=76ed075f"
import script from "./StyledVideojsPlayer.vue?vue&type=script&lang=js"
export * from "./StyledVideojsPlayer.vue?vue&type=script&lang=js"
import style0 from "./StyledVideojsPlayer.vue?vue&type=style&index=0&id=76ed075f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports